// API Configuration based on environment
import API_ENDPOINTS from './endpoints.json';

export const getEnvironment = (hostname = window.location.hostname) => {
  
  if (hostname === 'dev.anicha.earth') {
    return 'dev';
  } else if (hostname === 'anicha.earth' || hostname === 'www.anicha.earth' || 
             hostname === 'mzoom.space' || hostname === 'www.mzoom.space') {
    return 'prod';
  } else {
    // Default to dev for localhost and other environments
    return 'dev';
  }
};

const environment = getEnvironment();

// Export the endpoints for the current environment
export const apiConfig = API_ENDPOINTS[environment];

// Export environment info for debugging
export const currentEnvironment = environment;

// Log current configuration for debugging
console.log(`🌍 Environment: ${environment}`);
console.log('🔗 API Endpoints:', apiConfig);
